import {load} from '@shopify/theme-sections';
import ProductSection from '../sections/product';

load(ProductSection);
